// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divLoginLyceum{
  background-color: #6051b7;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: white;
  gap: 48px;
  padding: 0 0 0 0;
}


.divLoginLyceumLeft{
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.divLoginLyceumLeftItem{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.divLoginLyceumLeftImg{
  width: 500px;
}

.divLoginLyceumLeftLogo{
  width: 200px;
  height: auto;
}
.divLoginLyceumRight{
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap:24px;
}
.divLoginLyceumRightTitle{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.divSearchLyceumContentReturnRegister{
  display: flex;
  flex-direction: row;
  
}

.divLoginLyceumRightIconImg{
  width: 40px;
  height: none;
}

.divLoginLyceumRightIconImgLittleSize{
  width: 28px;
  height: none;
}
.divLoginLyceumModal{
  background-color: #6051b7;
  border-radius: 16px;
  padding:16px;
  display: flex;
  flex-direction: column;
  gap:16px;
  align-items: center;
  justify-content: center;
}

.divLoginLyceumbuttonCloseModal{
  padding: 10px;
  background-color: #939393;
  cursor:pointer;
  border-radius: 16px;
  width: 120px;
  height: 40px;
  border: none;
  color:#ffffff;
}
.divLoginLyceumRightInput{
  height: 50px;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  border-radius: 16px;
  padding-left: 20px;
  color: white;
  font-size: 18px;
  width: 350px;
  max-width: 350px;
}


.divLoginLyceumRightButtonInvisible{
  height: 50px;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 350px;
  cursor:pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(55, 55, 55, 0.2);
}

.divLoginLyceumRightButton{
  height: 50px;
  background-color: #E97247;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 350px;
  cursor:pointer;
}

.divLoginLyceumRightButton:hover{
  background-color: #ffffff;
  color: #E97247;
  font-size: 24px;
}

.divLoginLyceumRightButtonDisabled{
  height: 50px;
  background-color: #939393;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 350px;
  cursor:pointer;
}



.divLoginLyceumRightInput::placeholder {
  color: white;
}

.divLoginLyceumRightText{
  font-size: 32px;
}
.divLoginLyceumColumn{
  display: flex;
  flex-direction: column;
  gap:16px;
}

.divLoginLyceumRow{
  display: flex;
  flex-direction: row;
  gap:16px;
}

.divLoginLyceumTextAlert{
  font-size: 16px;
}

.modal.show .modal-dialog {
  width: 70vw;
  max-width: none;
  padding:10px;
}


.divLoginLyceumRightInputModal{
  height: 50px;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  border-radius: 16px;
  padding-left: 20px;
  color: white;
  font-size: 18px;
  width: 350px;
  max-width: 350px;
}



.divLoginLyceumRightInputModal::placeholder {
  color: white;
}

.divLoginLyceumRightButtonModal{
  height: 50px;
  background-color: #E97247;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 350px;
  cursor:pointer;
}


@media (max-width: 768px) {
  .modal.show .modal-dialog {
    width: 90vw;
    }
  .divLoginLyceum {
    flex-direction: column;
    min-height: 100vh;
    align-items: center;
    color: white;
    min-width: 100%;
    padding: 30px 0 50px 0;
  }

  .divLoginLyceumLeft{
    width: 100%;
    justify-content: center;
  }
  
  .divLoginLyceumRight{
    width: 100%;
    justify-content: center;
    align-items: center;
  }

    
  .divLoginLyceumLeftImg{
    width: 350px;
  }
  

.divLoginLyceumRightInputModal{
  height: 50px;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  border-radius: 16px;
  padding-left: 20px;
  color: white;
  font-size: 18px;
  width: 250px;
}


.divLoginLyceumRightButtonModal{
  height: 50px;
  background-color: #E97247;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 20px;
  width: 250px;
  cursor:pointer;
}

}`, "",{"version":3,"sources":["webpack://./src/pages/LoginLyceum/LoginLyceum.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;;AAGA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;;;AAIA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;;;AAIA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE;IACE,WAAW;IACX;EACF;IACE,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,mBAAmB;EACrB;;;EAGA;IACE,YAAY;EACd;;;AAGF;EACE,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA","sourcesContent":[".divLoginLyceum{\n  background-color: #6051b7;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  gap: 48px;\n  padding: 0 0 0 0;\n}\n\n\n.divLoginLyceumLeft{\n  width: 50%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.divLoginLyceumLeftItem{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.divLoginLyceumLeftImg{\n  width: 500px;\n}\n\n.divLoginLyceumLeftLogo{\n  width: 200px;\n  height: auto;\n}\n.divLoginLyceumRight{\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap:24px;\n}\n.divLoginLyceumRightTitle{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n}\n\n.divSearchLyceumContentReturnRegister{\n  display: flex;\n  flex-direction: row;\n  \n}\n\n.divLoginLyceumRightIconImg{\n  width: 40px;\n  height: none;\n}\n\n.divLoginLyceumRightIconImgLittleSize{\n  width: 28px;\n  height: none;\n}\n.divLoginLyceumModal{\n  background-color: #6051b7;\n  border-radius: 16px;\n  padding:16px;\n  display: flex;\n  flex-direction: column;\n  gap:16px;\n  align-items: center;\n  justify-content: center;\n}\n\n.divLoginLyceumbuttonCloseModal{\n  padding: 10px;\n  background-color: #939393;\n  cursor:pointer;\n  border-radius: 16px;\n  width: 120px;\n  height: 40px;\n  border: none;\n  color:#ffffff;\n}\n.divLoginLyceumRightInput{\n  height: 50px;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: none;\n  border-radius: 16px;\n  padding-left: 20px;\n  color: white;\n  font-size: 18px;\n  width: 350px;\n  max-width: 350px;\n}\n\n\n.divLoginLyceumRightButtonInvisible{\n  height: 50px;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 350px;\n  cursor:pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(55, 55, 55, 0.2);\n}\n\n.divLoginLyceumRightButton{\n  height: 50px;\n  background-color: #E97247;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 350px;\n  cursor:pointer;\n}\n\n.divLoginLyceumRightButton:hover{\n  background-color: #ffffff;\n  color: #E97247;\n  font-size: 24px;\n}\n\n.divLoginLyceumRightButtonDisabled{\n  height: 50px;\n  background-color: #939393;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 350px;\n  cursor:pointer;\n}\n\n\n\n.divLoginLyceumRightInput::placeholder {\n  color: white;\n}\n\n.divLoginLyceumRightText{\n  font-size: 32px;\n}\n.divLoginLyceumColumn{\n  display: flex;\n  flex-direction: column;\n  gap:16px;\n}\n\n.divLoginLyceumRow{\n  display: flex;\n  flex-direction: row;\n  gap:16px;\n}\n\n.divLoginLyceumTextAlert{\n  font-size: 16px;\n}\n\n.modal.show .modal-dialog {\n  width: 70vw;\n  max-width: none;\n  padding:10px;\n}\n\n\n.divLoginLyceumRightInputModal{\n  height: 50px;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: none;\n  border-radius: 16px;\n  padding-left: 20px;\n  color: white;\n  font-size: 18px;\n  width: 350px;\n  max-width: 350px;\n}\n\n\n\n.divLoginLyceumRightInputModal::placeholder {\n  color: white;\n}\n\n.divLoginLyceumRightButtonModal{\n  height: 50px;\n  background-color: #E97247;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 350px;\n  cursor:pointer;\n}\n\n\n@media (max-width: 768px) {\n  .modal.show .modal-dialog {\n    width: 90vw;\n    }\n  .divLoginLyceum {\n    flex-direction: column;\n    min-height: 100vh;\n    align-items: center;\n    color: white;\n    min-width: 100%;\n    padding: 30px 0 50px 0;\n  }\n\n  .divLoginLyceumLeft{\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .divLoginLyceumRight{\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n\n    \n  .divLoginLyceumLeftImg{\n    width: 350px;\n  }\n  \n\n.divLoginLyceumRightInputModal{\n  height: 50px;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: none;\n  border-radius: 16px;\n  padding-left: 20px;\n  color: white;\n  font-size: 18px;\n  width: 250px;\n}\n\n\n.divLoginLyceumRightButtonModal{\n  height: 50px;\n  background-color: #E97247;\n  border: none;\n  border-radius: 16px;\n  color: #ffffff;\n  font-size: 20px;\n  width: 250px;\n  cursor:pointer;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
